export const IMPORT_AS_OPTIONS = [
  { value: "leads", label: "Lead Pipeline" },
  { value: "policies", label: "Approved Policies / Servicing" },
  { value: "followups", label: "Follow-Up Queue / Sophia" },
  { value: "book_recovery", label: "Existing Book Recovery" },
  { value: "ref_carriers", label: "Reference · Carriers" },
  { value: "ref_products", label: "Reference · Products" },
  { value: "ref_states", label: "Reference · States" },
  { value: "ref_sources", label: "Reference · Lead Sources" },
  { value: "ref_vendors", label: "Reference · Vendors" },
  { value: "quarantine", label: "Quarantine (do not import)" },
];

const FOLLOWUP_FIELDS = [
  ["client_name", "Client Name"], ["phone", "Phone"], ["email", "Email"],
  ["policy_number", "Policy Number"], ["carrier", "Carrier"],
  ["policy_type", "Policy Type"], ["product_plan", "Product / Plan"],
  ["face_amount", "Face Amount"], ["monthly_premium", "Monthly Premium"],
  ["effective_date", "Effective Date"], ["scheduled_draft_date", "Scheduled Draft Date"],
  ["policy_status", "Policy Status"], ["payment_status", "Payment Status"],
  ["nsf_attempt_date", "NSF Attempt Date"], ["retry_date", "Retry Date"],
  ["status_state", "Follow-Up Status"], ["followup_type", "Follow-Up Type"],
  ["due_date", "Due Date"], ["assigned_to", "Assignee"], ["next_action", "Next Action"],
  ["notes", "Notes"], ["payment_issue", "Payment Issue"], ["policy_active", "Policy Active"],
  ["policy_facts_verified", "Policy Facts Verified"],
  ["payment_facts_verified", "Payment Facts Verified"],
];

const RECOVERY_FIELDS = [
  ["client_name", "Client Name"], ["phone", "Phone"], ["email", "Email"],
  ["carrier", "Carrier"], ["policy_number", "Policy / Application Number"],
  ["source_status", "Source Status"], ["payment_status", "Payment / Draft Status"],
  ["premium", "Monthly Premium"], ["draft_date", "Draft Date"],
  ["assigned_to", "Assignee"], ["notes", "Notes"],
];

export function fieldsForImportTarget(target, leadFields = [], policyFields = []) {
  if (target === "leads") return leadFields;
  if (target === "policies") return policyFields;
  if (target === "followups") return FOLLOWUP_FIELDS.map(([key, label]) => ({ key, label }));
  if (target === "book_recovery") return RECOVERY_FIELDS.map(([key, label]) => ({ key, label }));
  if (target?.startsWith("ref_")) return [{ key: "value", label: "Value (name)" }];
  return [];
}